export class Version {
    //replaced with real version before build for deployments via Azure Devops pipeline
    //see steps_build.yml
    static readonly ClientVersion = "10.6.9.36224";
}
